module.exports = __webpack_public_path__ + "img/img_leftd20blue.a43f5a15.png";